<template>
  <v-app>
    <MenuLateral></MenuLateral>

    <v-main ref="conteudo">
      <Header></Header>
      <transition name="scroll-x-transition" mode="out-in" @after-enter="focarTitulo">
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import MenuLateral from "@/components/EspacoDoColaborador/MenuLateral.vue";
import Header from "@/components/EspacoDoColaborador/Header.vue";

export default {
  data() {
    return {};
  },
  components: {
    Header,
    MenuLateral,
  },
  computed: {
    /* Largura que o menu lateral reserva à esquerda: 256px expandido, 56px em
       mini. É 0 no mobile, onde o drawer é temporary e passa por cima. */
    larguraMenuLateral() {
      return this.$vuetify.application.left || 0;
    },
  },
  watch: {
    /* Publica a largura numa CSS var para os dialogs se ajustarem ao menu em
       vez de ficarem por baixo dele (regra em assets/css/style.css). */
    larguraMenuLateral: {
      immediate: true,
      handler(px) {
        document.documentElement.style.setProperty("--menu-lateral-largura", `${px}px`);
      },
    },
  },
  methods: {
    focarTitulo() {
      const titulo = this.$refs.conteudo.$el.querySelector("h1");
      if (!titulo) return;

      titulo.setAttribute("tabindex", "-1");
      titulo.focus();
    },
  },
  beforeDestroy() {
    document.documentElement.style.removeProperty("--menu-lateral-largura");
  },
};
</script>

<style scoped>
</style>
